import { useAuth0 } from '@auth0/auth0-react'
import { Container, Tab, Tabs } from '@material-ui/core'
import { SaveButton } from 'components/Common/Button/SaveButton'
import { HorizontalScrollContainer } from 'components/Common/HorizontalScrollContainer'
import { CreateProjectForm } from 'components/Common/NewProject/CreateProjectForm/CreateProjectForm'
import { useCreateProject } from 'components/Common/NewProject/useCreateProject'
import { Dashboard } from 'components/Dashboard/Dashboard'
import { ProjectsListPage } from 'components/ProjectsPage/ProjectListPage'
import { ProjectsKanban } from 'components/ProjectsPage/ProjectsKanban'
import { useLocalStorage } from 'customHooks/useLocalStorage'
import { useAppRunningContext } from 'features/EmbeddedRh24/useAppRunningContext'
import React, { HTMLAttributes, useEffect, useState } from 'react'
import { useAppSelector } from 'store/configureStore'
import { ReactComponent as DashbardSvg } from '_icons/ui/dashboard.svg'
import { ReactComponent as KanbanSvg } from '_icons/ui/kanban.svg'
import { ReactComponent as ProjectsSvg } from '_icons/ui/my-projects.svg'
import { usePortalHomeStyles } from './PortalHome.styles'

const TabPanel = (
  props: HTMLAttributes<HTMLDivElement> & {
    children: React.ReactChild
    tab: string
    currentTab: string
  }
) => {
  const { children, currentTab, tab, ...other } = props

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (!loaded && currentTab === tab) {
      requestIdleCallback(() => setLoaded(true))
    }
  }, [loaded, currentTab, tab])

  return (
    <div
      role="tabpanel"
      hidden={tab !== currentTab}
      id={`home-tabpanel-${tab}`}
      aria-labelledby={`home-tabpanel-${tab}`}
      {...other}
    >
      {loaded ? children : null}
    </div>
  )
}

export const PortalHome = () => {
  const [currentTab, setCurrentTab] = useLocalStorage(
    'home-page:current-tab',
    'project-list'
  )
  const cn = usePortalHomeStyles()

  const handleTabChange = (_event, newValue: string) => {
    if (newValue === null || newValue === undefined) {
      return
    }

    setCurrentTab(newValue)
  }

  const { withinIframe } = useAppRunningContext()
  const { handleSubmit, submitting } = useCreateProject()

  const { isAuthenticated } = useAuth0()
  const userProfile = useAppSelector((state) => state.user.profile)

  if (!isAuthenticated || !userProfile) {
    return null
  }

  return (
    <>
      <Container maxWidth="xl" style={{ display: 'flex' }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          variant="fullWidth"
          style={{
            flexGrow: 1,
          }}
          centered
        >
          <Tab
            icon={
              <ProjectsSvg
                className="MuiSvgIcon-root"
                style={{ width: '1em', height: '1em' }}
              />
            }
            label="projects"
            value="project-list"
          />
          <Tab
            icon={
              <>
                <KanbanSvg
                  className="MuiSvgIcon-root"
                  style={{ width: '1em', height: '1em' }}
                />
              </>
            }
            label="kanban"
            value="kanban"
          />
          {withinIframe ? null : (
            <Tab
              icon={
                <>
                  <DashbardSvg
                    className="MuiSvgIcon-root"
                    style={{ width: '1em', height: '1em' }}
                  />
                </>
              }
              label="dashboard"
              value={'dashboard'}
            />
          )}
        </Tabs>
        <div
          className={cn.filter}
          style={{
            visibility:
              currentTab === 'dashboard' || currentTab === 'new-project'
                ? 'hidden'
                : 'visible',
          }}
          onClick={(e) => e.stopPropagation()}
        ></div>
      </Container>
      <TabPanel currentTab={currentTab} tab={'project-list'}>
        <Container maxWidth="xl">
          <ProjectsListPage />
        </Container>
      </TabPanel>
      <TabPanel currentTab={currentTab} tab={'kanban'}>
        <HorizontalScrollContainer className={cn.kanbanContainer}>
          <ProjectsKanban />
        </HorizontalScrollContainer>
      </TabPanel>
      <TabPanel currentTab={currentTab} tab={'dashboard'}>
        <Container maxWidth="xl">
          <div className={cn.dashboardContainer}>
            <Dashboard />
          </div>
        </Container>
      </TabPanel>
      <TabPanel currentTab={currentTab} tab={'new-project'}>
        <Container maxWidth="xl" className={cn.createProjectContainer}>
          <CreateProjectForm
            onSubmit={handleSubmit}
            formId="create-project-home-form"
            isSellerRole={false}
          />
          <div style={{ textAlign: 'right' }}>
            <SaveButton
              formId="create-project-home-form"
              saving={submitting}
              translationKey="common:create"
            />
          </div>
        </Container>
      </TabPanel>
    </>
  )
}
